function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M113 2.43h4.93v33.53H113z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M49.5 14.04c-6.31 0-11.45 4.82-11.45 11.46 0 6.6 5.14 11.46 11.45 11.46S60.95 32.1 60.95 25.5c0-6.64-5.14-11.46-11.45-11.46zm0 18.4c-3.46 0-6.44-2.86-6.44-6.94 0-4.12 2.98-6.94 6.44-6.94 3.46 0 6.44 2.82 6.44 6.94 0 4.08-2.98 6.94-6.44 6.94z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M74.5 14.09c-6.31 0-11.45 4.82-11.45 11.46 0 6.6 5.14 11.46 11.45 11.46s11.45-4.86 11.45-11.46c0-6.65-5.14-11.46-11.45-11.46zm0 18.4c-3.46 0-6.44-2.86-6.44-6.94 0-4.12 2.98-6.94 6.44-6.94s6.44 2.82 6.44 6.94c0 4.07-2.98 6.94-6.44 6.94z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M105.23 16.65h-.17c-1.13-1.34-3.3-2.56-6.03-2.56-5.73 0-10.98 5.03-10.98 11.5C88.05 32.01 93.3 37 99.03 37c2.73 0 4.9-1.22 6.03-2.6h.17v1.65c0 4.38-2.34 6.73-6.12 6.73-3.08 0-4.99-2.21-5.77-4.08l-4.38 1.82c1.26 3.04 4.6 6.77 10.15 6.77 5.9 0 10.89-3.47 10.89-11.93V15h-4.77v1.65zm-5.78 15.84c-3.47 0-6.38-2.91-6.38-6.9 0-4.04 2.91-6.99 6.38-6.99 3.43 0 6.12 2.95 6.12 6.99 0 3.99-2.69 6.9-6.12 6.9zm-71.22-4.08c1.39-1.39 2.32-3.42 2.67-6.41H19.22v-4.76H35.6c.17.87.3 2.06.3 3.2 0 3.66-1 8.19-4.22 11.41-3.14 3.27-7.14 5.01-12.46 5.01C9.38 36.86 1.1 28.84 1.1 19S9.38 1.14 19.22 1.14c5.44 0 9.32 2.13 12.24 4.92L28.02 9.5c-2.09-1.96-4.92-3.48-8.8-3.48-7.19 0-12.81 5.79-12.81 12.98s5.62 12.98 12.81 12.98c4.66 0 7.32-1.87 9.01-3.57z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M131.77 32.49c-2.56 0-4.38-1.17-5.55-3.47l15.32-6.34-.52-1.3c-.95-2.56-3.86-7.29-9.81-7.29-5.9 0-10.81 4.64-10.81 11.46 0 6.42 4.86 11.46 11.37 11.46 5.25 0 8.29-3.21 9.55-5.08l-3.91-2.6c-1.3 1.9-3.08 3.16-5.64 3.16zm-.39-13.98c2 0 3.69 1 4.25 2.43l-10.24 4.25c-.13-4.42 3.43-6.68 5.99-6.68z"
});

var SvgBrandingH48Px = function SvgBrandingH48Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 148,
    height: 48,
    viewBox: "0 0 148 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBrandingH48Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/branding_h48px.d92a7b5a.svg";
export { ForwardRef as ReactComponent };